/* Little Pup Club theme scripts */

(function () {
  'use strict';

  /* ---------- Hero slideshow ---------- */
  function initSlideshow(root) {
    var slides = root.querySelectorAll('.hero__slide');
    var dots = root.querySelectorAll('.hero__dot');
    if (slides.length < 2) return;
    var index = 0;
    var timer = null;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed || '6', 10) * 1000;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === index);
        s.setAttribute('aria-hidden', n === index ? 'false' : 'true');
      });
      dots.forEach(function (d, n) {
        d.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
    }
    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { show(index + 1); }, speed);
    }
    var prev = root.querySelector('.hero__arrow--prev');
    var next = root.querySelector('.hero__arrow--next');
    if (prev) prev.addEventListener('click', function () { show(index - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(index + 1); restart(); });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { show(n); restart(); });
    });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    show(0);
    restart();
  }

  /* ---------- Quantity buttons ---------- */
  function initQty(scope) {
    scope.querySelectorAll('[data-qty]').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.dataset.step === 'up' ? 1 : -1;
          var min = parseInt(input.min || '0', 10);
          var val = Math.max(min, (parseInt(input.value, 10) || 0) + step);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Product page ---------- */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var noDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var moneyFormat = root.dataset.moneyFormat;
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var button = root.querySelector('[data-add-button]');
    var selectedLabels = root.querySelectorAll('[data-selected-value]');
    var mainImg = root.querySelector('.product__main-media img');
    var thumbs = root.querySelectorAll('.product__thumb');

    function currentOptions() {
      var opts = [];
      root.querySelectorAll('fieldset.option').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function setMedia(src, srcset, mediaId) {
      if (!mainImg || !src) return;
      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', t.dataset.mediaId === String(mediaId) ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        setMedia(t.dataset.src, t.dataset.srcset, t.dataset.mediaId);
      });
    });

    function update() {
      var opts = currentOptions();
      selectedLabels.forEach(function (el, i) { el.textContent = opts[i] || ''; });
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!variant) {
        button.disabled = true;
        button.textContent = button.dataset.unavailable;
        return;
      }
      idInput.value = variant.id;
      var html = formatMoney(variant.price, moneyFormat);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += ' <s>' + formatMoney(variant.compare_at_price, moneyFormat) + '</s>';
      }
      priceEl.innerHTML = html;
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.add : button.dataset.soldout;
      if (variant.featured_media) {
        var thumb = root.querySelector('.product__thumb[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) setMedia(thumb.dataset.src, thumb.dataset.srcset, thumb.dataset.mediaId);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('fieldset.option input').forEach(function (input) {
      input.addEventListener('change', update);
    });
  }

  /* ---------- Collection filters ---------- */
  function initFilters(form) {
    var timer;
    form.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 350);
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations(el) {
    var url = el.dataset.url;
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var inner = html.querySelector('[data-recommendations]');
        if (inner && inner.querySelector('.card')) {
          el.innerHTML = inner.innerHTML;
        } else {
          el.remove();
        }
      })
      .catch(function () { el.remove(); });
  }

  /* ---------- Cart: update on quantity change ---------- */
  function initCart(form) {
    var timer;
    form.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var update = document.createElement('input');
          update.type = 'hidden';
          update.name = 'update';
          update.value = '1';
          form.appendChild(update);
          form.submit();
        }, 500);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    initQty(document);
    document.querySelectorAll('[data-product]').forEach(initProduct);
    document.querySelectorAll('[data-filter-form]').forEach(initFilters);
    document.querySelectorAll('[data-product-recommendations]').forEach(initRecommendations);
    document.querySelectorAll('[data-cart-form]').forEach(initCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init inside the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    initQty(e.target);
    e.target.querySelectorAll('[data-product]').forEach(initProduct);
  });
})();
